module.exports = __webpack_public_path__ + "img/AGENTE_TURISTICO.8eb5ed55.svg";